import { render, staticRenderFns } from "./TrueFalseSelector.vue?vue&type=template&id=a87e8d9e&"
import script from "./TrueFalseSelector.vue?vue&type=script&lang=js&"
export * from "./TrueFalseSelector.vue?vue&type=script&lang=js&"
import style0 from "./TrueFalseSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports